export default __webpack_public_path__ + "static/media/nft-longing.b893aebc.jpg";